import script from "./DistributionExpenses.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributionExpenses.vue?vue&type=script&setup=true&lang=js"

import "./DistributionExpenses.vue?vue&type=style&index=0&id=9c1196b6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c1196b6"]])

export default __exports__